import { TFunction } from 'i18next';
import * as yup from 'yup';
import { isEmailValid } from 'utils/email';

const MIN_LENGTH = 8;
const CONTAINS_WHITESPACE_REGEX = /\s/;

export const getPasswordValidationSchema = (t: TFunction) =>
  yup
    .string()
    .required(t('form.validation.fieldIsRequired'))
    .min(MIN_LENGTH, t('form.validation.password.minCharacters', { min: MIN_LENGTH }))
    .test('whitespace', t('form.validation.password.noWhitespace'), value => !CONTAINS_WHITESPACE_REGEX.test(value));

export const isEmailValidSchema = (t: TFunction) =>
  yup
    .string()
    .lowercase()
    .trim()
    .email(t('signup.steps.enterEmail.invalid'))
    .required(t('form.validation.fieldIsRequired'))
    .test('is-email-valid', t('signup.steps.enterEmail.invalid'), isEmailValid);
